import { memo, useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faMoon,
  faRightFromBracket,
  faSliders, faTrash,
  faUser,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { logout, toggleDarkMode } from "../../store/SiteSlice";
import { InputHelper } from "../../utils/InputHelper";
import { HtmlHelper } from "../../utils/HtmlHelper";
import { Button, Switch } from "antd";
import { UtilsService } from "../../services/UtilsService";
import { toast } from "react-toastify";
import _ from "lodash";
import { routeContants } from "../../utils/RouteConstants";

export interface UserDropdownProps {
  itemClickCallback?: Function;
}

export const UserDropdown = memo(function UserDropdown(props: UserDropdownProps) {
  const siteStore = useAppSelector((state) => state.site);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const selector = "user-dropdown";

  const [open, setOpen] = useState<boolean>(false);
  const [openSettingsMenu, setOpenSettingsMenu] = useState<boolean>(false);

  useEffect(() => {
    return HtmlHelper.clickOutside(selector, open, setOpen);
  }, [open]);

  const handleItemClick = () => {
    props.itemClickCallback && props.itemClickCallback();
  };

  const handleUserProfileSettingsClick = () => { };

  const handleClearCache = async () => {
    var result = await UtilsService.ClearCache({});
    if (result && result.header.success)
      toast(t("common.success"));
    else
      toast(_.first(result.header.messages)?.message);
  }

  const handleSignOut = useCallback(() => {
    dispatch(logout());
    navigate("/login");
  }, []);

  const handleUserAccountClick = () => {
    setOpen(false);
    navigate(routeContants.USER_ACCOUNT);
  };

  const handleHotelAccountClick = () => {
    setOpen(false);
    navigate(routeContants.HOTEL_ACCOUNT);
  };

  return (
    <li className="dropdown user-dropdown">
      <a
        onClick={() => setOpen(!open)}
        className="dropdown-toggle"
        id={selector}
      >
        <div className="user-toggle">
          <div className="user-avatar sm">
            <FontAwesomeIcon icon={faUser} />
          </div>
        </div>
      </a>
      <div
        className={`dropdown-menu dropdown-menu-md dropdown-menu-end dropdown-menu-s1 is-light user-drop ${open ? "show" : ""
          }`}
      >
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card">
            <div className="user-avatar">
              {siteStore.user &&
                siteStore.user.firstName &&
                siteStore.user.lastName ? (
                <span>
                  {InputHelper.getFirstLetters(
                    siteStore.user.firstName,
                    siteStore.user.lastName
                  )}
                </span>
              ) : (
                <span>{siteStore.user?.email?.toUpperCase().slice(0, 2)}</span>
              )}
            </div>
            <div className="user-info">
              {siteStore.user?.firstName && siteStore.user.lastName ? (
                <span className="lead-text">{`${siteStore.user.firstName} ${siteStore.user.lastName}`}</span>
              ) : (
                <span className="lead-text">
                  {siteStore.user?.email?.split("@")[0]}
                </span>
              )}
              {siteStore.user?.email && (
                <span className="sub-text">{siteStore.user.email}</span>
              )}
            </div>

          </div>
        </div>
        <div className="dropdown-inner">
          <ul className="link-list">
            <li>
              <a
                className="pointer"
                onClick={handleUserAccountClick}
              >
                <FontAwesomeIcon icon={faUser} />
                <span className="icon-item-label">
                  {t("userMenu.userAccount")}
                </span>
              </a>
            </li>
            <li>
              <a
                className="pointer"
                onClick={handleHotelAccountClick}
              >
                <FontAwesomeIcon icon={faBuilding} />
                <span className="icon-item-label">
                  {t("userMenu.hotelAccount")}
                </span>
              </a>
            </li>

            <li>
              <a className="pointer">
                <FontAwesomeIcon icon={faMoon} />
                <span className="icon-item-label">
                  {t("userMenu.darkMode")}
                </span>
                <Switch className="menu-toggler"
                  checked={siteStore.darkMode && String(siteStore.darkMode) === "true" ? true : false}
                  onChange={() => dispatch(toggleDarkMode())} />
              </a>
            </li>
            {/*
            <li>
              <a className="pointer" onClick={() => handleClearCache()}>
                <FontAwesomeIcon icon={faTrash} />
                <span className="icon-item-label">
                  {t("userMenu.clearCache")}
                </span>
              </a>
            </li>
            */}
          </ul>
        </div>
        <div className="dropdown-inner">
          <ul className="link-list">
            <li>
              <a className="pointer" onClick={handleSignOut}>
                <FontAwesomeIcon icon={faRightFromBracket} />
                <span className="icon-item-label">{t("userMenu.signOut")}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </li>
  );
});
